<template>
  <v-container
    fluid
    class="found-leak v-card v-sheet space"
    fill-height
  >
    <v-layout
      align-space-around
      justify-space-around
      row
      wrap
    >
      <v-flex xs9>
        <v-layout
          align-space-around
          justify-space-around
          column
        >
          <v-flex>
            <v-select
              v-model="reason"
              :items="reasons"
              item-text="displayName"
              item-value="key"
              :label="strings.reason"
              accent
              :class="reasonClass"
              :error="reasonClass.missing"
            />
          </v-flex>
          <v-flex>
            <v-select
              v-model="equipmentUsed"
              :items="equipmentList"
              item-value="id"
              item-text="name"
              :menu-props="{ maxHeight: '400' }"
              :label="strings.equipmentUsed"
              multiple
              hint="List any equipment used"
              :class="equipmentUsedClass"
              :error="equipmentUsedClass.missing"
            />
          </v-flex>
          <v-flex
            grow
            class="center"
          >
            <v-btn
              fab
              small
              color="primary"
              @click="onDeleteLeak"
            >
              <v-icon color="text">
                mdi-delete
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { NoLeakReasons } from "../config/leak.js";
import { DetectionMethods } from "../config/equipment.js";
import { mapGetters } from "vuex";
export default {
  name: "FoundLeak",
  props: [
    "leak",
    "highlightMissingEquipmentUsed",
    "highlightMissingReason"
  ],
  data() {
    return {
      localReason: null,
      localEquipmentUsed: [],
      rules: {
        required: value => value.length > 0 || "Required",
        counter: value => value.length <= 20 || "Max 12 characters",
        notNull: value => !!value || "Required"
      }
    };
  },
  computed: {
    ...mapGetters("page", ["strings"]),
    ...mapGetters("settings", ["setting"]),
    reasons() {
      return NoLeakReasons.sort(this.namedSort);
    },
    equipmentList() {
      var methods = DetectionMethods.sort(this.namedSort);

      if(this.setting.plasticEquipment && this.hasPlastic) {
        var arr = [];
        methods.forEach(m => {
          var exists = this.setting.plasticEquipmentList.find(l => l == m.id);
          if(exists) {
            arr.push(m);
          }
        })

        methods = arr;
      }
      else {
        var arr = [];
        methods.forEach(m => {
          var exists = this.setting.equipmentList.find(l => l == m.id);
          if(exists) {
            arr.push(m);
          }
        })

        methods = arr;
      }
      return methods;
    },
    reasonClass() {
      return {
        missing: this.highlightMissingReason && this.localReason == null
      };
    },
    equipmentUsedClass() {
      return {
        missing:
          this.highlightMissingEquipmentUsed && this.localEquipmentUsed == 0
      };
    },
    reason: {
      get() {
        return this.leak.reason != null ? Number(this.leak.reason) : null;
      },
      set(value) {
        this.localReason = value;
        this.leak.reason = value;
      }
    },
    equipmentUsed: {
      get() {
        return this.leak.equipmentUsed != null
          ? this.leak.equipmentUsed.map(x => Number(x))
          : null;
      },
      set(value) {
        this.localEquipmentUsed = value;
        this.leak.equipmentUsed = [...value];
      }
    },
  },
  mounted() {
    if (this.leak) {
      if (this.leak.reason) {
        this.localReason = this.leak.reason;
      }
      if (this.leak.equipmentUsed) {
        this.localEquipmentUsed = this.leak.equipmentUsed;
      }
    }
  },
  methods: {
    onDeleteLeak() {
      this.$emit("delete");
    },
    namedSort(a, b) {
      let nameA = a.name.toUpperCase(); // ignore upper and lowercase
      let nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      // names must be equal
      return 0;
    }
  }
};
</script>

<style scoped>
.flex.grow.center {
  align-items: center;
  justify-content: center;
  display: flex;
}

.container.fluid.fill-height.found-leak {
  background-color: #00000020;
  padding: 0rem 0rem 0.75rem 0.75rem;
}
.found-leak.space {
  margin-top: 0.5rem;
}

.v-btn.v-btn--outline.thick {
  border: 4px solid;
}

.missing {
  animation: shake 2.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  animation-iteration-count: infinite;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
}

@keyframes shake {
  2%,
  18% {
    transform: translate3d(-1px, 0, 0);
  }

  4%,
  16% {
    transform: translate3d(2px, 0, 0);
  }

  6%,
  10%,
  14% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  12% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
